// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorQuoteThresholds = (client) => ({
    /**
     * `POST /vendor/quote-thresholds`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/quote-thresholds/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/quote-thresholds", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/quote-thresholds/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/quote-thresholds/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/quote-thresholds`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListQuoteThresholds
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/quote-thresholds/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/quote-thresholds", { method: "GET", query, headers }),
    /**
     * `GET /vendor/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/quote-thresholds/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/quote-thresholds/:id", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /vendor/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/vendor/quote-thresholds/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/quote-thresholds/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=quote-thresholds.js.map